import styled from 'styled-components';

export const ScInputPromo = styled.div`
  position: relative;
  height: fit-content;
  margin-top: 16px;
  .form-group {
    &__row {
      display: grid;
      grid-template-columns: 1fr 100px;
      gap: 8px;
    }
  }
  & .info-message {
    display: flex;
    gap: 4px;
    align-items: center;
    margin-top: 4px;
    color: ${({ theme }) => theme.whiteColor};
    padding: 0 16px 0 8px;
    font-size: 12px;
    line-height: 18px;
    letter-spacing: 0px;
  }
`;
